
export function useMatchFormats() {
  const { $i18n } = useNuxtApp()
  const { t } = $i18n

  const isNearDate = (date) => {
    const now = new Date()
    const target = new Date(date)
    const diffDays = Math.abs((target - now) / (1000 * 60 * 60 * 24))
    return diffDays <= 1
  }

  const formatMatchDate = (date) => {
    const dateObj = typeof date === 'string' ? new Date(date) : date
    if (!dateObj || isNaN(dateObj)) return 'TBD'
    const day = String(dateObj.getDate()).padStart(2, '0')
    const month = dateObj.toLocaleString($i18n.locale.value, { month: 'short' }).toUpperCase()
    return `${day} ${month}`
  }

  const formatMatchTime = (date, time) => {
    if (!(date && time)) {
      return 'TBD'
    }
    return formatTime([date, time].join(' '))
  }

  function formatMatchDay(date) {
    if (!date) return 'TBD'

    const input = new Date(date)
    const now = new Date()

    const isSameDay = (d1, d2) =>
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()

    if (isSameDay(input, now)) return t('string.Today').toUpperCase()

    const tomorrow = new Date()
    tomorrow.setDate(now.getDate() + 1)
    if (isSameDay(input, tomorrow)) return t('string.Tomorrow').toUpperCase()

    return input.toLocaleString($i18n.locale.value, { weekday: 'long' }).toUpperCase()
  }

  const formatMatchTitle = (title) => {
    let clubs = []

    if (title.includes(' v ')) {
      clubs = title.split(' v ')
    } else if (title.includes(' vs ')) {
      clubs = title.split(' vs ')
    }

    if (clubs.length === 2) {
      return `
      <div>
        <span class="upcoming-games-overview-card__event-info-club-name">
          ${clubs[0].trim()}
        </span>
        <!-- <img class="upcoming-games-overview-card__event-info-club-badge" src="#" width="23px" height="28px" alt="club's icon"> -->
      </div>
      <span class="vs">vs</span>
      <div>
        <!-- <img class="upcoming-games-overview-card__event-info-club-badge" src="#" width="23px" height="28px" alt="club's icon"> -->
        <span class="upcoming-games-overview-card__event-info-club-name">
          ${clubs[1].trim()}
        </span>
      </div>
    `
    }

    return `
    <div>
      <span class="upcoming-games-overview-card__event-info-club-name">
        ${title}
      </span>
    </div>
  `
  }

  return {
    isNearDate,
    formatMatchDate,
    formatMatchTime,
    formatMatchDay,
    formatMatchTitle,
  }
}
